import { $ } from '../helpers/query-selector';
import { reducedMotion } from '../helpers/variables';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';

function init() {
  const translations = JSON.parse($('.js-slideshow').dataset.translations);

  const swiper = new Swiper('.js-slideshow', {
    modules: [Navigation, Pagination, A11y],
    loop: true,
    speed: reducedMotion.matches ? 0 : 800,
    navigation: {
      nextEl: '.js-slideshow-button-next',
      prevEl: '.js-slideshow-button-prev'
    },
    pagination: {
      el: '.js-slideshow-pagination',
      clickable: true
    },
    a11y: {
      ...translations
    }
  });
}

export default init;
